import { ActionTypes } from "../contants/action-types";

const initialState = {
    txnCategory:[]
}

export const txnTypesReducer = (state=initialState, {type, payload})=>{
    switch(type){
        case ActionTypes.GET_TXN_TYPES:
        //   return {...state, chartofAcconts:payload};
          return payload;
        default:
          return state;
    }

}